import React, { useEffect, useState } from "react";
import { Button } from "../../shared/inputs";
import { NetworkAxios, UserActivityAxios } from "../../API";
import Avatar from "../../shared/commonComponents/Avatar";
import { useSelector, useDispatch } from "react-redux";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { CONNECTION_STATUS } from "../../shared/Enum";
//import Profile from '../../shared/profile/Profile';
import authSlice from "../../store/auth/authSlice";
import GradientButton from "../../shared/inputs/GradientButton";
import CdxModal from "../../shared/modal/CdxModal";

const TeamMember = (props) => {
  const dispatch = useDispatch();
  const [btnLabel, setBtnLabel] = useState("Connect");
  const [btnColor, setBtnColor] = useState("");
  const [conflictConnection, setConflictConnection] = useState(false);
  const [receivedConnection, setReceivedConnection] = useState([]);

  const loggedInUser = useSelector((state) => state.auth.loggedInUser);

  let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };
  // messagePoint.activityId = indivisualActivityId;

  useEffect(() => {
    if (props.connectionStatus == CONNECTION_STATUS.requestSent) {
      setBtnLabel("Request sent");
      setBtnColor("C00FFCA");
    } else if (props.connectionStatus == CONNECTION_STATUS.requestRecieved) {
      setBtnLabel("Approve request");
    } else if (props.connectionStatus == CONNECTION_STATUS.connected) {
      setBtnLabel("Connected");
      setBtnColor("C00FFCA");
    } else {
      setBtnLabel("Connect");
      setBtnColor("");
    }
  });

  const buttonAction = (e) => {
    if (props.connectionStatus == CONNECTION_STATUS.requestRecieved) {
      var requestData = {
        message: messagePoint,
        isBackgroundJob: false,
      };
      NetworkAxios.post(
        "Connection/acceptconnection?connectionId=" + props.connectionId,
        requestData
      )
        .then(function (response) {
          console.log(response.data);
          props.updateStatus(props.offeringUserId, 3);
          var notificationData = [
            {
              offeringId: loggedInUser.offeringId,
              missionId: loggedInUser.missionId,
              activityBy: loggedInUser.offeringUserId,
              offeringUserId: props.offeringUserId,
              teamId: loggedInUser.teamId,
              notificationText: `accepted your connection request.`,
              actionRoute: JSON.stringify({ action: null, actionText: "NA" }),
            },
          ];

          var requestObject = {
            requestModel: notificationData,
            message: messagePoint,
            isBackgroundJob: false,
          };

          UserActivityAxios.post(
            "Notification/sendnotifications",
            requestObject
          )
            .then(function (res) { })
            .catch(function (er) {
              console.log(er);
            });
        })
        .catch(function (error) { });
    }

    if (props.connectionStatus === CONNECTION_STATUS.sendRequest) {
      var requestData = {
        requestModel: {
          offeringUserId: props.offeringUserId,
          sender: props.userId,
          connectionStatus: 0,
        },
        message: messagePoint,
        isBackgroundJob: false,
      };
      NetworkAxios.post("/Connection/sendconnection", requestData)
        .then(function (response) {
          console.log(response.data);

          if (response.data.isPresent) {
            setReceivedConnection(response.data);
            setConflictConnection(true);
          } else {
            props.updateStatus(props.offeringUserId, 1);

            var notificationData = [
              {
                offeringId: loggedInUser.offeringId,
                missionId: loggedInUser.missionId,
                activityBy: loggedInUser.offeringUserId,
                offeringUserId: props.offeringUserId,
                teamId: loggedInUser.teamId,
                notificationText: `sent you a connection request.`,
                actionRoute: JSON.stringify({
                  action: "send-connection",
                  sender: props.userId,
                  connectionId: response.id,
                  actionText: "View",
                }),
              },
            ];

            var requestObject = {
              requestModel: notificationData,
              message: messagePoint,
              isBackgroundJob: false,
            };
            UserActivityAxios.post(
              "Notification/sendnotifications",
              requestObject
            )
              .then(function (res) { })
              .catch(function (er) {
                console.log(er);
              });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const approveRequest = () => {
    setConflictConnection(false);
    var requestData = {
      message: messagePoint,
      isBackgroundJob: false,
    };
    NetworkAxios.post(
      "Connection/acceptconnection?connectionId=" + receivedConnection.id,
      requestData
    ).then(function (response) {
      props.updateStatus(props.offeringUserId, 3);
      var notificationData = [
        {
          offeringId: loggedInUser.offeringId,
          missionId: loggedInUser.missionId,
          activityBy: loggedInUser.offeringUserId,
          offeringUserId: receivedConnection.sender,
          teamId: loggedInUser.teamId,
          notificationText: `accepted your connection request.`,
          actionRoute: JSON.stringify({ action: null, actionText: "NA" }),
        },
      ];

      var requestObject = {
        requestModel: notificationData,
        message: messagePoint,
        isBackgroundJob: false,
      };

      UserActivityAxios.post("Notification/sendnotifications", requestObject)
        .then(function (res) { })
        .catch(function (er) {
          console.log(er);
        });
    });
  };

  const openProfile = (userid, offeringuserid) => {
    dispatch(
      authSlice.actions.setProfileData({
        userId: userid,
        offeringUserId: offeringuserid,
      })
    );
    dispatch(
      authSlice.actions.setProfileStack({
        userId: userid,
        offeringUserId: offeringuserid,
      })
    );
    dispatch(authSlice.actions.setProfileLoader({ showLoader: true }));
    dispatch(authSlice.actions.showProfile());
    setTimeout(function () {
      dispatch(authSlice.actions.setProfileLoader({ showLoader: false }));
    }, 2000);
  };

  let className = props.className
    ? "team-member " + props.className
    : "team-member";
  //let frame = props.frame ? props.frame : "";

  const popover = (
    <Popover id="popover-basic" className="profilePopover">
      <div className="popover-profile-top-section">
        {/* <div className="profile-picture">
              <div className="profile-avatar">
              <UserThumbnail currentUser={true} className="profile-avatar" />
              </div>
            </div> */}
        <Avatar {...props} className="small" />
        <div className="profile-details">
          <div className="profile-name">
            {props.firstName + " " + props.lastName}
          </div>
          <div className="profile-teamname">{props.teamName}</div>
          <div className="profile-missionname">{props.missionName}</div>
        </div>
      </div>
      <div className="popover-profile-bottom-section">
        <div className="profile-email">{props.email}</div>
        <div
          className="profile-view"
          onClick={() => {
            openProfile(props.id, props.offeringUserId);
          }}
        >
          View Profile
        </div>
      </div>
    </Popover>
  );

  return (
    <>
      {/* <Profile></Profile> */}
      <div className={className}>
        <Avatar {...props} className="medium" />
        <div className="details">
          <OverlayTrigger
            trigger="click"
            placement="top"
            overlay={popover}
            rootClose
          >
            <span className="name" style={{ cursor: "pointer" }}>
              {props.firstName + " " + props.lastName}
            </span>
           
          </OverlayTrigger>
          {props.teamName&&<div style={{marginBottom:"10px"}}>
              {props.teamName}
            </div>}
          <Button
            className={btnColor}
            style={{ minWidth: "120px", maxWidth: "120px" }}
            onClick={(e) => buttonAction(e)}
          >
            {btnLabel}
          </Button>
        </div>
      </div>
      <CdxModal
        show={conflictConnection}
        onHide={() => setConflictConnection(false)}
        onClose={() => setConflictConnection(false)}
        className="info-model"
      >
        <CdxModal.Header onClose={() => setConflictConnection(false)}>
          Confirmation
        </CdxModal.Header>
        <CdxModal.Body>
          <div className="">
            {props.firstName + " " + props.lastName} has just sent you a
            connection request. Please approve to connect!
          </div>
          <div className="d-flex ms-auto">
            <button
              className="approve-btn cdx-btn"
              onClick={() => {
                approveRequest();
              }}
            >
              Approve
            </button>
          </div>
        </CdxModal.Body>
      </CdxModal>
    </>
  );
};

export default TeamMember;
